<template>
  <v-row>
    <v-col cols="12" class="pb-0 text-uppercase">
      <span>
        {{
          `${endereco.logradouro}, ${endereco.bairro}, ${endereco.numero ||
            "S/N"} - ${endereco.cidade.nome}/${endereco.cidade.estado.sigla}`
        }}
      </span>
    </v-col>
    <v-col v-if="endereco.complemento" cols="12" class="pt-0">
      <span>
        {{ `Complemento: ${endereco.complemento}` }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      endereco: this.value.matricula.pessoa.endereco
    };
  }
};
</script>
